import { Container, Sprite } from "pixi.js";
import { PiggyResourcePackage } from "../../resources/PiggyResourcePackage";

export class PiggyViewHeaderComponent extends Container {
    protected readonly piggyResources: PiggyResourcePackage;

    protected readonly background: Sprite;

    public constructor(piggyResources: PiggyResourcePackage) {
        super();
        this.piggyResources = piggyResources;
        this.background = new Sprite(this.piggyResources.assets_views_piggy_top_tooltip_png);
        this.addChild(this.background);
    }
}
